import * as React from 'react';
import { styled, ThemeProvider, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import Typography from '@mui/material/Typography';
import {getBs4Style} from '../../Bs4Components/Bs4Utils'

import Bs4Stores from '../../Bs4Stores'
import Bs4GenericField from './Bs4GenericField'

export default class Bs4TextSelect extends Bs4GenericField {

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.bs4Store.find(item => item.id == value) || null;
      if (!value) {
        value = this.bs4Store[0] || null;
        // console.log('...Bs4TextSelect...<><>', this.props?.field?.fieldLabel, '>',valueOrg, '<', value, this.bs4Store);
      }
    } else {
      this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
      value = this.bs4Store.find(item => item.id == value) || null;
    }
    this.setValue(value);
  }

  getValueBs4 () {    
    return this.value?.id || '';
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  ViewOption = (props) => {
    const theme = useTheme();
    if (props?.option && !('bs4Style' in props.option)) props.option.bs4Style = getBs4Style(props?.option?.style);
    if (props.option.bs4Style && !props.option.icon) props.option.icon = "fa-solid fa-circle";

    return (
      <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={0.5}>
        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
          {props.option?.icon ?
            <Box
              className={props.option?.icon}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                //width: 25,
                height: 25,
                aspectRatio: '1/1',
                border: 'none', //'1px solid currentColor',
                borderRadius: theme.shape.borderRadius+'px',
                //borderRadius: '999px',
                //boxShadow: theme.shadows[1],
                ...props?.option.bs4Style
              }}
            />
            :
            null
          }
          <Typography variant='body1' sx={{color: theme.palette.text.primary, whiteSpace: 'pre-line'}}>{props?.option.name}</Typography>
        </Stack>
        {props.option?.text ? 
          <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{props?.option.text}</Typography> : null}
      </Stack>
    )
  }

  ViewComponentField = (props) => {
    const formField = this;    
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [bs4Store, setBs4Store] = React.useState(formField.bs4Store || []);
    this.refFocus = React.useRef();
    const theme = useTheme();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {
        //console.log('... notValidElementDom .select.', text)
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);

      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);
        this.setValueBs4(this.getValueBs4());
      };
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, setError, setValue, setBs4Store]);

    const handleChange = (event, newValue) => {
      // console.log('=== OnChange ===', newValue);
      const newOption = bs4Store.find(option => option.id === newValue)
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(newOption);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    }

    const handleChangeButton = (option) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(option);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    }

    // console.log('=== select butt ===', formField.getLabelPlane(), props, value);

    return (
      <FormControl fullWidth  error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box>
          <ToggleButtonGroup 
            ref={this.refFocus}
            value={value?.id || ''} 
            orientation='vertical'
            exclusive 
            //onChange={handleChange} 
            variant='contained' 
          >
            {bs4Store.map(option => { 
              if (!('bs4style' in option)) option.bs4style = getBs4Style(option?.style);
              return (
                <ToggleButton 
                  key={option?.id} 
                  value={option?.id}
                  onClick={() => handleChangeButton(option)}
                  sx={{
                    textAlign: 'left', 
                    justifyContent:'left'}}
                >
                  <formField.ViewOption option={option}/>
                </ToggleButton>
              )})}
          </ToggleButtonGroup>
        </Box>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}